import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, ArrowLeft } from 'lucide-react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

const MORADA = 'Rua Manuel Dourado Eusébio N.º 34 A, Salir, Portugal, 8100-202';
// Link para abrir no Google Maps (localização exata Electro Salir)
const MAPS_LINK = 'https://maps.app.goo.gl/3hSMDnVBPXXk2GW47';
// Embed: pesquisa pelo nome do negócio para o pin cair na Electro Salir Lda.
const MAPS_EMBED_URL = `https://www.google.com/maps?q=${encodeURIComponent('Electro Salir Lda, ' + MORADA)}&z=17&output=embed`;

export default function SiteContactos() {
  return (
    <div className="min-h-screen bg-gestao-background text-slate-800">
      <SiteHeader />
      <main className="pt-24 pb-16 px-4 sm:px-6">
        <div className="max-w-5xl mx-auto">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gestao-primary font-semibold hover:underline mb-8"
          >
            <ArrowLeft size={18} />
            Voltar ao início
          </Link>

          <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-2">
            Contactos
          </h1>
          <p className="text-slate-600 mb-10">
            Visite-nos ou contacte-nos pelos meios abaixo.
          </p>

          <div className="grid lg:grid-cols-2 gap-10 lg:gap-12 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-sm border border-slate-200">
              <h2 className="text-xl font-bold text-slate-900 mb-6">
                Electro Salir Lda.
              </h2>
              <p className="text-slate-500 text-sm mb-6">NIF 502 529 962</p>
              <ul className="space-y-5">
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gestao-primary/10 rounded-lg flex items-center justify-center shrink-0">
                    <MapPin size={20} className="text-gestao-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800 mb-1">Morada</p>
                    <p className="text-slate-600">{MORADA}</p>
                    <a
                      href={MAPS_LINK}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gestao-primary text-sm font-medium hover:underline mt-2 inline-block"
                    >
                      Abrir no Google Maps →
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gestao-primary/10 rounded-lg flex items-center justify-center shrink-0">
                    <Phone size={20} className="text-gestao-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800 mb-1">Telefone</p>
                    <a href="tel:+351289489848" className="text-slate-600 hover:text-gestao-primary">
                      289 489 848
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gestao-primary/10 rounded-lg flex items-center justify-center shrink-0">
                    <Phone size={20} className="text-gestao-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800 mb-1">Telemóvel</p>
                    <a href="tel:+351917869307" className="text-slate-600 hover:text-gestao-primary">
                      917 869 307
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-10 h-10 bg-gestao-primary/10 rounded-lg flex items-center justify-center shrink-0">
                    <Mail size={20} className="text-gestao-primary" />
                  </div>
                  <div>
                    <p className="font-semibold text-slate-800 mb-1">E-mail</p>
                    <a
                      href="mailto:electrosalir@sapo.pt"
                      className="text-slate-600 hover:text-gestao-primary"
                    >
                      electrosalir@sapo.pt
                    </a>
                  </div>
                </li>
              </ul>
            </div>

            <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-sm bg-white">
              <h2 className="text-lg font-bold text-slate-900 p-4 border-b border-slate-200">
                Localização
              </h2>
              <div className="relative w-full aspect-[4/3] min-h-[280px] bg-slate-100">
                <iframe
                  title="Localização Electro Salir - Google Maps"
                  src={MAPS_EMBED_URL}
                  width="100%"
                  height="100%"
                  style={{ border: 0, position: 'absolute', top: 0, left: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="absolute inset-0 w-full h-full"
                />
              </div>
              <p className="p-3 text-center text-sm text-slate-500 bg-slate-50 border-t border-slate-200">
                Para abrir a localização exata da Electro Salir Lda. no Google Maps,{' '}
                <a
                  href={MAPS_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gestao-primary font-medium hover:underline"
                >
                  clique aqui
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
